import { JetView } from 'webix-jet';

/**
 * Class representing the FilterPromotionalCodesView.
 * Extends JetView to create a view for filtering promotional codes.
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing input fields for filtering
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Input for ID
                            minWidth: 200,
                            name: 'Id',
                            type: 'number',
                            label: _('ID'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'text', // Input for ISO code
                            minWidth: 200,
                            name: 'Iso',
                            label: _('Iso'),
                            labelPosition: 'top',
                            placeholder: _('Iso'),
                        },
                        {
                            view: 'text', // Input for country name
                            minWidth: 200,
                            name: 'NameCountry',
                            label: _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'text', // Input for currency
                            minWidth: 200,
                            name: 'Currency',
                            label: _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Moneda'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Input for UTC
                            minWidth: 200,
                            name: 'UTC',
                            label: _('UTC'),
                            labelPosition: 'top',
                            placeholder: _('UTC'),
                        },
                        {
                            view: 'text', // Input for language
                            minWidth: 200,
                            name: 'Language',
                            label: _('Lenguaje'),
                            labelPosition: 'top',
                            placeholder: _('Lenguaje'),
                        },
                        {
                            view: 'text', // Input for cell prefix
                            minWidth: 200,
                            name: 'CellPrefix',
                            label: _('Prefijo celular'),
                            labelPosition: 'top',
                            placeholder: _('Prefijo celular'),
                        },
                        {
                            view: 'text', // Input for code path
                            minWidth: 200,
                            name: 'CodePath',
                            label: _('Código PATH'),
                            labelPosition: 'top',
                            placeholder: _('Código PATH'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left input fields
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with values
                                ]);
                                $$('b5').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };

        // Second button section for actions in the popup
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Clear button for popup
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').clear(); // Clears the popup form
                            },
                        },
                        {
                            view: 'button', // Consult button for popup
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get popup form values
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with values
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section containing filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Scrollable section for filters
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };

        // Popup window for filter options
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title of the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion and buttons in the popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for main form
            },
        };
    }
}

// FILE DOCUMENTED
